import { render, staticRenderFns } from "./DialogVersion.vue?vue&type=template&id=4bc90671"
import script from "./DialogVersion.vue?vue&type=script&lang=ts"
export * from "./DialogVersion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports